import type React from 'react';
import { useCallback } from 'react';

import { type GenericShowFlag, type SlackWorkspace } from '../../../types';
import { useThirdPartyIntegrationsFlags } from '../../Flags/ThirdPartyIntegrations';
import { setConnectedSlackWorkSpace, disconnectSlackWorkSpace } from '../localStorageUtils';
import { PLATFORM_SLACK_SERVICE } from '../constants';
import { type ThirdPartyContextAnalytics } from './ThirdPartyContextAnalytics';

interface Arguments {
	analytics: ThirdPartyContextAnalytics;
	setSelectedSlackWorkspace: React.Dispatch<React.SetStateAction<SlackWorkspace | null>>;
	showFlag?: GenericShowFlag<any>;
}

export const useOnChangeSelectedSlackWorkspace = ({
	analytics,
	setSelectedSlackWorkspace,
	showFlag,
}: Arguments) => {
	const thirdPartyIntegrationsFlags = useThirdPartyIntegrationsFlags();

	return useCallback(
		(selectedSlackWorkspace: SlackWorkspace) => {
			setSelectedSlackWorkspace(selectedSlackWorkspace);
			// We'll make sure to remove the settings for the product slack app if
			// we are using the platform slack app
			disconnectSlackWorkSpace();
			setConnectedSlackWorkSpace(selectedSlackWorkspace.id);

			analytics.integrationConnected({
				serviceKey: PLATFORM_SLACK_SERVICE,
				teamId: selectedSlackWorkspace.id,
			});

			if (showFlag) {
				showFlag(
					thirdPartyIntegrationsFlags.success(PLATFORM_SLACK_SERVICE, selectedSlackWorkspace.name),
				);
			}
		},
		[analytics, setSelectedSlackWorkspace, showFlag, thirdPartyIntegrationsFlags],
	);
};
